module.exports = __webpack_public_path__ + "static/media/btn_message.3fef42bd.svg";